import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AttemptService {

  readonly rootURL = environment.apiurl+"attempt/";

  constructor(private http: HttpClient) { }
  
  
  takeAttempt(attempt):any{
    return this.http.post(this.rootURL+`takeattempt`,attempt).toPromise();
  }
  getAttemptsHistory(email):any{
    return this.http.get(this.rootURL+`attemptshistory`).toPromise();
  }
  getAttemptScript(schId):any{
    return this.http.get(this.rootURL+`attemptscript?schId=${schId}`).toPromise();
  }
}
